module.exports = __webpack_public_path__ + "img/sdg_10.6ec23713.png";